import * as React from 'react';
import axios from 'axios';
import icon_search from './icon_search.svg';
import { useZstdHeader } from 'header/header/useZstdHeader';
import { UserProfileBtn } from 'header/userprofile/UserProfileBtn';
import { useLoginInfo } from 'hooks/useLoginInfo';
import { MobileSrchInput } from 'mainpage/toparea/srchinput/MobileSrchInput';
import { useZstdSrch } from 'mainpage/toparea/srchinput/useZstdSrch';
import { IfLoginInfo } from 'models/IfLoginInfo';
import styled from 'styled-components';
import { loginutil } from 'util/loginutil';
import { useZstdInfo } from 'zstd/useZstdInfo';
import { MainMenuIcon } from '../mainmenu/MainMenuIcon';
import icon_earth from './icon_earth.svg';
import icon_earth_white from './icon_earth_white.svg';
import { useWinResize } from 'zstd/useZstdWinResize';

type Props = {
  main: boolean;
  headerRef?: React.RefObject<HTMLDivElement>;
};
export const MobileMenuIcon = (props: Props) => {
  const loginInfo = useLoginInfo();

  const { setShowSearchBoxPopup, showUserPopup, setShowUserPopup } = useZstdInfo();
  const { isLoadingUserPopup, alertNewAlarm } = useZstdHeader();
  const { setShowMobileSrch } = useZstdSrch();

  const checkNewAlarmCount = async (loggedInAccountId) => {
    axios
      .post('/api/member/ssqData/user/alarm/count/new', {
        userId: loggedInAccountId,
      })
      .then((res) => {
        useZstdHeader.setState({
          alertAlarmCount: res.data,
          alertNewAlarm: res.data > 0 ? true : false,
        });
      });
  };

  const openUserPopup = async (showUserPopup) => {
    if (!showUserPopup) {
      await useZstdHeader.setState({ isLoadingUserPopup: true });

      await useZstdHeader.setState({ countrySelect: false });
      setShowUserPopup(!showUserPopup);

      const info: IfLoginInfo = (await axios.get('/api/guest/loginInfo')).data;
      if (info.userId) await checkNewAlarmCount(info.userId);

      useZstdHeader.setState({ isLoadingUserPopup: false });
    } else {
      useZstdHeader.setState({ isLoadingUserPopup: false });
      useZstdHeader.setState({ countrySelect: false });
      setShowUserPopup(!showUserPopup);
    }
  };

  const handleClickUserProfile = async (e) => {
    e.stopPropagation();
    setShowSearchBoxPopup(false);
    if (loginutil.islogin(loginInfo)) await checkNewAlarmCount(loginInfo?.userId);
    await openUserPopup(showUserPopup);
  };
  const { setCountrySelect } = useZstdHeader();

  const { main, headerRef } = props;
  const { isMobile } = useWinResize();
  return (
    <MobileMenuBody>
      {!main && isMobile && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setShowMobileSrch(true);
          }}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img alt={'icon search'} src={icon_search} style={{ width: '2.4rem', height: '2.4rem' }} />
          </div>
        </button>
      )}
      <div
        className="flex items-center"
        onClick={(e) => {
          e.stopPropagation();
          setCountrySelect(true);
          setShowUserPopup(false);
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', lineHeight: '24px'}}>
          <img
            alt={'icon_earth.svg'}
            src={main ? icon_earth_white : icon_earth}
            style={{ width: '2.4rem', height: '2.4rem' }}
          />
        </div>
      </div>
      <UserProfileBtn
        onClick={handleClickUserProfile}
        loginInfo={loginInfo}
        isLoadingUserPopup={isLoadingUserPopup}
        alertNewAlarm={alertNewAlarm}
        isMobile={true}
      />

      <MainMenuIconWrap>
        <MainMenuIcon main={main} mobile headerRef={headerRef} />
      </MainMenuIconWrap>

      <MobileSrchInput />
    </MobileMenuBody>
  );
};

const MainMenuIconWrap = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  left: 0;
`;

const MobileMenuBody = styled.div`
  display: none;
  height: 100%;

  @media screen and (max-width: 1199px) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1.6rem;
    .my-icon-area {
      width: 2.4rem;
      height: 100%;
      flex-shrink: 0;
      display: flex;
      align-items: center;

      img {
        vertical-align: middle;
      }
    }
  }
  @media screen and (max-width: 764px) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1.6rem;
  }
`;
